export default __webpack_public_path__ + "static/media/PeraAlgo.d89dd6c7.svg";